import { render, staticRenderFns } from "./dialogList1.vue?vue&type=template&id=d680865a"
import script from "./dialogList1.vue?vue&type=script&lang=js"
export * from "./dialogList1.vue?vue&type=script&lang=js"
import style0 from "./dialogList1.vue?vue&type=style&index=0&id=d680865a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports